import { CommonData } from '../common_schema'

export const coprocessorData: CommonData[] = [
  {
    name: 'handle duration(p99 for all request types)',
    mean: 'P99_coprocessor_handle_duration:total.values.mean',
    std: 'P99_coprocessor_handle_duration:total.values.std',
    location: 'TiKV-Details --> Coprocessor Detail --> handle duration'
  },
  {
    name: 'wait duration(p99 for all request types)',
    mean: 'P99_coprocessor_wait_duration:total.values.mean',
    std: 'P99_coprocessor_wait_duration:total.values.std',
    location: 'TiKV-Details --> Coprocessor Detail --> wait duration'
  },
  {
    name: 'Running tasks(avg between TiKVs)',
    mean: 'unified_read_pool_running_tasks:total.values.mean',
    std: 'unified_read_pool_running_tasks:total.values.std',
    location: 'TiKV-Details --> Unified Read Pool --> Running tasks'
  },
  {
    name: 'Time used by level(avg between TiKVs)',
    mean: 'time_used_by_level_avg:total.values.mean',
    std: 'time_used_by_level_avg:total.values.std',
    location: 'TiKV-Details --> Unified Read Pool --> Time used by level'
  }
]
